{
  "cancel": "Annulla",
  "delete": "Elimina",
  "close": "Chiudi",
  "done": "Fatto",
  "deleteTitle": "Eliminare il record?",
  "deleteText": "Eliminare definitivamente questo record?",
  "info": "Informazioni",
  "objectInfoTitle": "Informazioni sul record",
  "createdBy": "Creato da",
  "createdAt": "Creato il",
  "lastEditedBy": "Ultima modifica di",
  "editedAt": "Modificato il",
  "unknown": "Sconosciuto",
  "system": "Sistema",
  "objectHistoryTitle": "Registrazione e cronologia",
  "changes": "Modifiche",
  "loadingHistory": "Caricamento cronologia…",
  "noHistory": "Nessuna cronologia delle modifiche finora.",
  "historyLoadError": "Impossibile caricare la cronologia.",
  "someone": "Qualcuno",
  "historyDate": "Data",
  "historyUser": "Utente",
  "historyChange": "Modifica",
  "actionCreated": "creato",
  "actionDeleted": "eliminato",
  "actionChanged": "modificato",
  "historyFallbackWithTitle": "“{{title}}” {{verb}}",
  "historyFallback": "Voce {{verb}}",
  "updateAvailable": "Aggiornamento disponibile",
  "updateBody": "È disponibile una nuova versione di questa app.\nÈ necessario un aggiornamento per la migliore esperienza possibile.",
  "updateLater": "Aggiorna più tardi",
  "updateNow": "Aggiorna",
  "internetRequired": "(Internet richiesto)",
  "releaseInfo": "Note di rilascio",
  "selectMandant": "Seleziona tenant",
  "noLicence": "Nessuna licenza disponibile",
  "noCompanyAssigned": "Non sei assegnato a nessuna azienda.",
  "companiesLoadError": "Impossibile caricare le aziende",
  "logout": "Disconnetti"
}
